import React, {
  useState,
  useMemo,
  useEffect,
  useLayoutEffect,
  useRef,
} from 'react';
import LS from '../styles/layoutStyled';
import CS from '../styles/componentStyled';
import styled from 'styled-components';
import { theme } from '../styles/theme';
import {
  blankDefaultMsgRecoil,
  errorMsgRecoil,
  confirmMsgRecoil,
  roomWorkNumModifyStateRecoil,
} from '../atom/ModalAtom';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import { userIdState } from '../atom/TokenAtom';
import { EntryListsDto, EntryListDto, RoomInforDto } from '../model/room.dto';
import WorkNum from './WorkNum';
import { lineIdStateRecoil, refreshDataState } from '../atom/RoomAtom';
import { socketio } from '../api/socket.api';
import eventbus from '../api/eventbus';
import { roomAPI } from '../api/axiosIndex';
import CheckBox from './CheckBox';
import { refreshDataStateRecoil } from '../atom/CommonAtom';

interface EntryListProps {
  roomInfor: RoomInforDto | null;
  lineId: number;
  userPosition: string | undefined;
  refreshData: boolean;
  checkIdArray: string[];
  setCheckIdArray: (checkIdArray: string[]) => void;
  onClick?: () => void;
}

const EntryList = ({
  roomInfor,
  lineId,
  userPosition,
  refreshData,
  checkIdArray,
  setCheckIdArray,
  onClick,
}: EntryListProps) => {
  const blankMsg = useRecoilValue(blankDefaultMsgRecoil);
  const setError = useSetRecoilState(errorMsgRecoil);
  const setConfirm = useSetRecoilState(confirmMsgRecoil);

  const [userId, setUserId] = useRecoilState(userIdState);
  const refreshDataFlag = useRecoilValue(refreshDataState);

  const [activeEntry, setActiveEntry] = useState<number | null>(null);
  const [entryLists, setEntryLists] = useState<EntryListsDto | null>(null);
  const [modifyEntryLists, setModifyEntryLists] =
    useState<EntryListsDto | null>(null);

  const [roomWorkNumModifyState, setRoomWorkNumModifyState] = useRecoilState(
    roomWorkNumModifyStateRecoil,
  );

  // 방 상세에서 본인 탕수 수정할 때 lineId를 받아올 방법이 없어서 여기는 리코일로 사용
  const [lineIdState, setLineIdState] = useRecoilState(lineIdStateRecoil);

  // 입차 리스트 조회
  const getEntryLists = async () => {
    try {
      const response = await roomAPI.getEntryLists(lineId);
      setEntryLists(response.data);
    } catch (error: any) {
      console.log(error);
    }
  };

  // 대기 추가
  const handleWait = async (id: number) => {
    try {
      await roomAPI.putWait(Number(lineId), String(id));
      socketio.entry(Number(lineId));
      setConfirm('대기가 추가되었습니다.');
    } catch (error: any) {}
  };

  // 입차 리스트 조회 useEffect
  useEffect(() => {
    getEntryLists();
  }, [refreshData]);

  // 입출차 이벤트 처리
  useEffect(() => {
    eventbus.on('entry', () => {
      getEntryLists();
    });
    eventbus.on('entryOrder', () => {
      setConfirm('방장에 의해 출차 승인되었습니다.');
    });
    eventbus.on('entryCancel', () => {
      setError('방장에 의해 입차 취소되었습니다.');
    });
    const handleAutosort = () => {
      getEntryLists();
    };
    eventbus.on('autosort', handleAutosort);

    return () => {
      eventbus.off('autosort', handleAutosort);
    };
  }, []);

  return (
    <>
      {entryLists?.map((list, index) => (
        <li
          className={`${list.position === 'Borrowed' ? 'basic-member' : 'fix-member'} ${list.userId === userId ? 'my' : ''} ${list.wait ? 'wait' : ''}`}
          key={list.id}
        >
          <div className="left-box">
            {userPosition === 'Master' && (
              <CheckBox
                checkIdArray={checkIdArray}
                setCheckIdArray={setCheckIdArray}
                checkValue={String(list.id)}
              />
            )}
            <div className="title-box">
              <h1>순번 {index + 1}</h1>
              <UserInfoWrap>
                {list.userNumber !== '' && list.userNumber !== null && (
                  <h2>{list.userNumber}</h2>
                )}
                {list.otherText !== '' && list.otherText !== null && (
                  <p>{list.otherText}</p>
                )}
              </UserInfoWrap>
            </div>
          </div>
          <div className="right-box">
            {userPosition !== 'Borrowed' && list.position !== 'Borrowed' && (
              <ul
                className="work-num-box"
                onClick={() => {
                  if (list.userId === userId) {
                    setRoomWorkNumModifyState(true);
                    setLineIdState(lineId);
                  }
                }}
              >
                <li>
                  <h4>오늘</h4>
                  <span className="num">
                    <WorkNum listId={list.userId} type="today" />건
                  </span>
                </li>
                <li>
                  <h4>실</h4>
                  <span className="num">
                    <WorkNum listId={list.userId} type="month" />건
                  </span>
                </li>
                <li>
                  <h4>누적</h4>
                  <span className="num">
                    <WorkNum listId={list.userId} type="all" />건
                  </span>
                </li>
              </ul>
            )}
            {userPosition === 'Master' && (
              <MiniBtn
                className={list.wait ? 'active' : ''}
                onClick={() => {
                  handleWait(list.id);
                }}
              >
                대기
              </MiniBtn>
            )}
          </div>
        </li>
      ))}
    </>
  );
};

export default EntryList;

export const UserInfoWrap = styled.div`
  display: flex;
  flex-direction: column;
`;

export const MiniBtn = styled.button`
  width: 32px;
  min-width: 32px;
  max-width: 32px;
  height: 24px;
  border-radius: 4px;
  font-size: 12px;
  box-sizing: border-box;
  cursor: pointer;
  border: 1px solid ${theme.mainColor3};
  background-color: #fff;
  color: ${theme.mainColor3};
  &.active {
    border: 1px solid ${theme.mainColor3};
    background-color: ${theme.mainColor3};
    color: #fff;
  }
  &.disabled {
    border: 1px solid #bbb;
    background-color: #bbb;
    color: #fff;
    cursor: default;
  }
`;
